import { createContext } from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SettingsOmnibusContext = /*#__PURE__*/createContext({
  settingsOmnibus: null,
  setSettingsOmnibus: () => void 0
});
export const SettingsOmnibusContextProvider = ({
  children
}) => {
  const [settingsOmnibus, setSettingsOmnibus] = useState(null);
  return /*#__PURE__*/_jsx(SettingsOmnibusContext.Provider, {
    value: {
      settingsOmnibus,
      setSettingsOmnibus
    },
    children: children
  });
};
export const useSettingsOmnibusContext = () => {
  return useContext(SettingsOmnibusContext);
};